import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './SelectFieldWithDatatest.scss';
import UpArrow from '../Icons/UpArrow';
import DownArrow from '../Icons/DownArrow';

const SelectFieldWithDatatest = ({
  value, onChange, options, clearable, className, placeholder, searchPromptText,
  displayArrow = true, searchable, loadOptions,
  noResultsText, async, disabled, cache, valueKey, autofocus, dataTest
}) => {
  const arrowRenderer = ({ isOpen }) =>
    (displayArrow && (isOpen ? <UpArrow width='16' height='16' color='#818A98' />
      : <DownArrow width='16' height='16' color='#818A98' />)
    );

  const filterOptions = (options, filter, currentValues) => {
    // Do no filtering, just return all options
    return options;
  };

  arrowRenderer.propTypes = {
    isOpen: PropTypes.bool
  };

  return (
    async
      ? <div data-test={dataTest}><Select.Async
        className={className}
        placeholder={placeholder}
        searchPromptText={searchPromptText}
        value={value}
        onChange={onChange}
        clearable={clearable}
        arrowRenderer={arrowRenderer}
        searchable={searchable}
        loadOptions={loadOptions}
        noResultsText={noResultsText}
        disabled={disabled}
        cache={cache}
        valueKey={valueKey}
        filterOptions={filterOptions}
        autofocus={autofocus}

      /></div>
      : <div data-test={dataTest}><Select
        className={className}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        options={options}
        clearable={clearable}
        arrowRenderer={arrowRenderer}
        searchable={searchable}
        noResultsText={noResultsText}
        disabled={disabled}
        valueKey={valueKey}
        data-test={dataTest}
      /></div>
  );
};

SelectFieldWithDatatest.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  clearable: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  searchPromptText: PropTypes.string,
  displayArrow: PropTypes.bool,
  searchable: PropTypes.bool,
  loadOptions: PropTypes.func,
  noResultsText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  async: PropTypes.bool,
  disabled: PropTypes.bool,
  cache: PropTypes.any,
  valueKey: PropTypes.string,
  dataTest: PropTypes.string
};

export default SelectFieldWithDatatest;
